import './SearchTopResultsCard.scss'

import { QuickLinksItemType, QuickLinksType, TopResultsItemType, TopResultsType } from '@react/SearchResults/SearchTypes'
import { trackEvent } from '@site/js/utils/tracking'
import { ReactElement } from 'react'

type SearchTopResultsCardProps = {
  searchObject: TopResultsType | QuickLinksType
}

const isExternal = (link: string) => !link.startsWith('/')

export function SearchTopResultsCard({ searchObject }: SearchTopResultsCardProps): ReactElement {
  const { title, items } = searchObject

  const analyticsLayer = (searchLink: TopResultsItemType | QuickLinksItemType, searchObject: TopResultsType | QuickLinksType) => {
    trackEvent({
      event: 'interaction',
      eventSource: 'aem',
      action: 'click',
      componentName: 'search-results',
      interactionType: searchObject.title.split(' ').join('-').toLowerCase(),
      title: searchLink.linkText,
      href: (searchLink as QuickLinksItemType).link || (searchLink as TopResultsItemType).searchCriteria,
    })
  }
  return (
    <div className="top-search-card" data-testid="search-top-results-card-component">
      <p className="top-search-card__title" data-testid="search-top-results-card-title">
        {title}
      </p>
      {items?.map((searchLink: TopResultsItemType | QuickLinksItemType) => (
        <a
          href={(searchLink as QuickLinksItemType)?.link || (searchLink as TopResultsItemType).searchCriteria}
          className="top-search-card__link"
          key={searchLink.linkText}
          onClick={() => analyticsLayer(searchLink, searchObject)}
          data-testid="search-top-results-card-link"
          target={isExternal((searchLink as QuickLinksItemType).link || (searchLink as TopResultsItemType).searchCriteria) ? '_blank' : null}
          rel={
            isExternal((searchLink as QuickLinksItemType).link || (searchLink as TopResultsItemType).searchCriteria) ? 'noreferrer noopener' : null
          }
        >
          <span className="top-search-card__link-text">{searchLink.linkText}</span>
          <span className="cmp-button__icon cmp-button__icon--arrow_right"></span>
        </a>
      ))}
    </div>
  )
}
